import { createElement } from 'react';

var uid = (function () {
  return Math.random().toString(36).substring(2);
});

var Wrap = function Wrap(props) {
  var idClip = props.uniquekey ? props.uniquekey + '-idClip' : uid();
  var idGradient = props.uniquekey ? props.uniquekey + '-idGradient' : uid();

  return createElement(
    'svg',
    {
      viewBox: '0 0 ' + props.width + ' ' + props.height,
      version: '1.1',
      style: props.style,
      preserveAspectRatio: props.preserveAspectRatio,
      className: props.className
    },
    createElement('rect', {
      style: { fill: 'url(#' + idGradient + ')' },
      clipPath: 'url(#' + idClip + ')',
      x: '0',
      y: '0',
      width: props.width,
      height: props.height
    }),
    createElement(
      'defs',
      null,
      createElement(
        'clipPath',
        { id: idClip },
        props.children
      ),
      createElement(
        'linearGradient',
        { id: idGradient },
        createElement(
          'stop',
          { offset: '0%', stopColor: props.primaryColor },
          props.animate ? createElement('animate', {
            attributeName: 'offset',
            values: '-2; 1',
            dur: props.speed + 's',
            repeatCount: 'indefinite'
          }) : null
        ),
        createElement(
          'stop',
          { offset: '50%', stopColor: props.secondaryColor },
          props.animate ? createElement('animate', {
            attributeName: 'offset',
            values: '-1.5; 1.5',
            dur: props.speed + 's',
            repeatCount: 'indefinite'
          }) : null
        ),
        createElement(
          'stop',
          { offset: '100%', stopColor: props.primaryColor },
          props.animate ? createElement('animate', {
            attributeName: 'offset',
            values: '-1; 2',
            dur: props.speed + 's',
            repeatCount: 'indefinite'
          }) : null
        )
      )
    )
  );
};

var FacebookStyle = function FacebookStyle(props) {
  return createElement(
    ContentLoader,
    props,
    createElement('rect', { x: '70', y: '15', rx: '4', ry: '4', width: '117', height: '6.4' }),
    createElement('rect', { x: '70', y: '35', rx: '3', ry: '3', width: '85', height: '6.4' }),
    createElement('rect', { x: '0', y: '80', rx: '3', ry: '3', width: '350', height: '6.4' }),
    createElement('rect', { x: '0', y: '100', rx: '3', ry: '3', width: '380', height: '6.4' }),
    createElement('rect', { x: '0', y: '120', rx: '3', ry: '3', width: '201', height: '6.4' }),
    createElement('circle', { cx: '30', cy: '30', r: '30' })
  );
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var InstagramStyle = function InstagramStyle(props) {
  return createElement(
    ContentLoader,
    _extends({}, props, { height: 480 }),
    createElement('circle', { cx: '30', cy: '30', r: '30' }),
    createElement('rect', { x: '75', y: '13', rx: '4', ry: '4', width: '100', height: '13' }),
    createElement('rect', { x: '75', y: '37', rx: '4', ry: '4', width: '50', height: '8' }),
    createElement('rect', { x: '0', y: '70', rx: '5', ry: '5', width: '400', height: '400' })
  );
};

var CodeStyle = function CodeStyle(props) {
  return createElement(
    ContentLoader,
    props,
    createElement('rect', { x: '0', y: '0', rx: '3', ry: '3', width: '70', height: '10' }),
    createElement('rect', { x: '80', y: '0', rx: '3', ry: '3', width: '100', height: '10' }),
    createElement('rect', { x: '190', y: '0', rx: '3', ry: '3', width: '10', height: '10' }),
    createElement('rect', { x: '15', y: '20', rx: '3', ry: '3', width: '130', height: '10' }),
    createElement('rect', { x: '155', y: '20', rx: '3', ry: '3', width: '130', height: '10' }),
    createElement('rect', { x: '15', y: '40', rx: '3', ry: '3', width: '90', height: '10' }),
    createElement('rect', { x: '115', y: '40', rx: '3', ry: '3', width: '60', height: '10' }),
    createElement('rect', { x: '185', y: '40', rx: '3', ry: '3', width: '60', height: '10' }),
    createElement('rect', { x: '0', y: '60', rx: '3', ry: '3', width: '30', height: '10' })
  );
};

var ListStyle = function ListStyle(props) {
  return createElement(
    ContentLoader,
    props,
    createElement('rect', { x: '0', y: '0', rx: '3', ry: '3', width: '250', height: '10' }),
    createElement('rect', { x: '20', y: '20', rx: '3', ry: '3', width: '220', height: '10' }),
    createElement('rect', { x: '20', y: '40', rx: '3', ry: '3', width: '170', height: '10' }),
    createElement('rect', { x: '0', y: '60', rx: '3', ry: '3', width: '250', height: '10' }),
    createElement('rect', { x: '20', y: '80', rx: '3', ry: '3', width: '200', height: '10' }),
    createElement('rect', { x: '20', y: '100', rx: '3', ry: '3', width: '80', height: '10' })
  );
};

var BulletListStyle = function BulletListStyle(props) {
  return createElement(
    ContentLoader,
    props,
    createElement('circle', { cx: '10', cy: '20', r: '8' }),
    createElement('rect', { x: '25', y: '15', rx: '5', ry: '5', width: '220', height: '10' }),
    createElement('circle', { cx: '10', cy: '50', r: '8' }),
    createElement('rect', { x: '25', y: '45', rx: '5', ry: '5', width: '220', height: '10' }),
    createElement('circle', { cx: '10', cy: '80', r: '8' }),
    createElement('rect', { x: '25', y: '75', rx: '5', ry: '5', width: '220', height: '10' }),
    createElement('circle', { cx: '10', cy: '110', r: '8' }),
    createElement('rect', { x: '25', y: '105', rx: '5', ry: '5', width: '220', height: '10' })
  );
};

var defaultProps = {
  animate: true,
  speed: 2,
  width: 400,
  height: 130,
  preserveAspectRatio: 'xMidYMid meet',
  primaryColor: '#f0f0f0',
  secondaryColor: '#e0e0e0'
};

var InitialComponent = function InitialComponent(props) {
  return createElement('rect', { x: '0', y: '0', rx: '5', ry: '5', width: props.width, height: props.height });
};

var ContentLoader = function ContentLoader(props) {
  var mergedProps = _extends({}, defaultProps, props);
  var children = props.children ? props.children : createElement(InitialComponent, mergedProps);

  return createElement(
    Wrap,
    mergedProps,
    children
  );
};

export { defaultProps, FacebookStyle as Facebook, InstagramStyle as Instagram, CodeStyle as Code, ListStyle as List, BulletListStyle as BulletList };
export default ContentLoader;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-content-loader/dist/react-content-loader.es.js
// module id = 170
// module chunks = 0